
var printingDocumentModule = angular.module('printingDocumentModule', []);

printingDocumentModule.controller("printingDocumentController", ['$scope', '$http', '$compile', '$sce', '$window', '$timeout', function ($scope, $http, $compile, $sce, $window, $timeout) {
    $scope.documentInformation = {};

    $scope.init = function () {
        $http.get(handbookRequests.GetDocumentInformationRequest, { params: { 'documentId': documentViewModel.documentId } }).
               success(function (data, status, headers, config) {
                   $scope.documentInformation = data;
                   $scope.documentInformation.fieldContents.forEach(function (fieldContent) {
                       fieldContent.content = $sce.trustAsHtml(fieldContent.content);
                   });
                   $scope.page.setTitle($scope.documentInformation.documentName);
                   $timeout(function () {
                       $window.print();
                   });
                   
        });
    };

}]);